module.exports = __webpack_public_path__ + "static/media/img-app-feature-1@2x.8a005bb5.png";